(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity steppers on the cart page: clamp to min/max, then submit the cart form (page reload).
  (function () {
    'use strict';

    const form = document.getElementById('cart-form');
    if (!form || form.dataset.qtyBound) return;
    form.dataset.qtyBound = 'true';

    const clamp = (input, value) => {
      const min = Number(input.min || 0);
      const max = input.max === '' ? Infinity : Number(input.max);
      return Math.max(min, Math.min(max, value));
    };

    form.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-qty-btn]');
      if (!btn || btn.disabled) return;
      const input = document.getElementById(btn.getAttribute('data-qty-for'));
      if (!input) return;
      const next = clamp(input, Number(input.value || 1) + Number(btn.getAttribute('data-qty-btn')));
      if (next === Number(input.value)) return;
      input.value = String(next);
      form.requestSubmit();
    });

    form.addEventListener('change', (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      input.value = String(clamp(input, Number(input.value || 1)));
      form.requestSubmit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discovery"]) return;
  try {
    
  // Discovery Box builder (the FAQ is native <details>). Section JS is bundled by Shopify, so it boots every
  // .discovery-product root once (data-discovery-ready) and again after theme-editor re-renders.
  (function () {
    'use strict';

    function initPicker(root) {
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-slot]'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-lot]'));
      var hint = root.querySelector('[data-discovery-picker-hint]');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-atc]'));
      // Grind: the checked radio's .vk-chip label gets .is-active; the legend shows the value.
      var grinds = Array.prototype.slice.call(root.querySelectorAll('[data-discovery-grind]'));
      var grindLabel = root.querySelector('[data-discovery-grind-label]');
      function syncGrind() {
        grinds.forEach(function (r) {
          var chip = r.closest('.vk-chip');
          if (chip) chip.classList.toggle('is-active', r.checked);
          if (r.checked && grindLabel) grindLabel.textContent = r.value;
        });
      }
      grinds.forEach(function (r) {
        r.addEventListener('change', syncGrind);
      });
      syncGrind();
      // Mobile: once the builder panel has scrolled above the viewport, keep the sticky bar
      // visible to the end of the page; hide it again only when the panel is back on screen.
      var mbar = root.querySelector('[data-discovery-mbar]');
      var panelEl = root.querySelector('.dsc__panel');
      if (mbar && panelEl && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          var en = e[0];
          var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          mbar.classList.toggle('is-on', passed);
          root.classList.toggle('has-mbar', passed);
        }, { threshold: 0.15 }).observe(panelEl);
      }
      var slotCount = 3;
      var busy = false;

      if (selects.length === 0) return;

      function ids() {
        return selects.map(function (select) {
          return parseInt(select.value, 10) || 0;
        });
      }

      function isComplete() {
        var values = ids().filter(function (id) { return id > 0; });
        return values.length === slotCount && new Set(values).size === slotCount;
      }

      function syncDuplicates() {
        var values = ids();
        selects.forEach(function (select, index) {
          Array.prototype.forEach.call(select.options, function (opt) {
            var val = parseInt(opt.value, 10) || 0;
            if (!val) {
              opt.disabled = false;
              return;
            }
            opt.disabled = values.some(function (id, i) {
              return i !== index && id === val;
            });
          });
        });
      }

      function syncCards() {
        var values = ids();
        cards.forEach(function (card) {
          var id = parseInt(card.getAttribute('data-discovery-lot'), 10) || 0;
          var slot = values.indexOf(id);
          var selected = slot >= 0;
          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', selected ? 'true' : 'false');
          var num = card.querySelector('[data-discovery-lot-num]');
          if (num) num.textContent = selected ? 'W zestawie' : 'Dodaj';
        });
      }

      function lotMeta(id) {
        if (!id) return { country: '—', name: '', accent: 'var(--color-border-strong)', price: 0 };
        var card = root.querySelector('[data-discovery-lot="' + id + '"]');
        return {
          country: card ? card.getAttribute('data-discovery-country') || '—' : '—',
          name: card ? card.getAttribute('data-discovery-name') || '' : '',
          accent: card ? card.getAttribute('data-discovery-accent') || 'var(--color-border-strong)' : 'var(--color-border-strong)',
          price: card ? parseInt(card.getAttribute('data-discovery-price'), 10) || 0 : 0
        };
      }

      function syncSlots() {
        var values = ids();
        root.querySelectorAll('[data-discovery-ui-slot]').forEach(function (el) {
          var index = parseInt(el.getAttribute('data-discovery-ui-slot'), 10);
          var meta = lotMeta(values[index] || 0);
          var filled = (values[index] || 0) > 0;
          var countryEl = el.querySelector('[data-discovery-slot-country]');
          var nameEl = el.querySelector('[data-discovery-slot-name]');
          el.classList.toggle('is-filled', filled);
          el.classList.toggle('is-empty', !filled);
          el.style.setProperty('--discovery-slot-accent', filled ? meta.accent : 'transparent');
          if (countryEl) countryEl.textContent = filled ? meta.country : 'Wybierz kawę';
          if (nameEl) nameEl.textContent = filled ? meta.name : '';
          el.setAttribute(
            'aria-label',
            filled
              ? 'Zestaw, pozycja ' + (index + 1) + ': ' + meta.country + '. Kliknij, żeby zdjąć.'
              : 'Zestaw, pozycja ' + (index + 1) + ' pusta. Wybierz kawę z listy.'
          );
        });
      }

      function syncDock() {
        var filled = ids().filter(function (id) { return id > 0; }).length;
        var count = root.querySelector('[data-discovery-dock-count]');
        if (count) {
          // Only the leading text node changes; the "różne kawy" <span> stays as rendered.
          var label = filled + ' / ' + slotCount + ' ';
          if (count.firstChild && count.firstChild.nodeType === 3) {
            count.firstChild.nodeValue = label;
          } else {
            count.insertBefore(document.createTextNode(label), count.firstChild);
          }
        }
        var panel = root.querySelector('[data-discovery-count]');
        if (panel) panel.textContent = 'Zestaw · ' + filled + '/' + slotCount;
      }

      function syncHero() {
        var values = ids();
        root.querySelectorAll('[data-discovery-tasting-row]').forEach(function (row, index) {
          var meta = lotMeta(values[index] || 0);
          var country = row.querySelector('[data-discovery-tasting-country]');
          var swatch = row.querySelector('[data-discovery-tasting-swatch]');
          var filled = (values[index] || 0) > 0;
          var label = filled && meta.country && meta.country !== '—' ? meta.country : 'Wybierz kawę';
          var accent = filled ? (meta.accent || 'var(--color-border-strong)') : 'var(--color-border-strong)';
          row.classList.toggle('is-on', filled);
          row.classList.toggle('is-off', !filled);
          row.style.setProperty('--ticket-accent', accent);
          if (country) country.textContent = label;
          if (swatch) swatch.style.background = accent;
        });
      }

      function syncButton() {
        var ok = isComplete();
        buttons.forEach(function (button) {
          button.disabled = !ok || busy;
          button.setAttribute('aria-disabled', ok && !busy ? 'false' : 'true');
        });
        if (hint) {
          hint.hidden = false;
          hint.textContent = ok
            ? 'Zestaw gotowy.'
            : 'Trzy różne kawy. Ten sam lot nie wchodzi dwa razy.';
        }
      }

      function sync() {
        syncDuplicates();
        syncCards();
        syncSlots();
        syncHero();
        syncDock();
        syncButton();
      }

      function assignLot(id) {
        var values = ids();
        var existing = values.indexOf(id);
        if (existing >= 0) {
          selects[existing].value = '';
          sync();
          return;
        }
        var empty = values.findIndex(function (value) { return value === 0; });
        if (empty >= 0) {
          selects[empty].value = String(id);
          sync();
          return;
        }
        if (hint) hint.hidden = false;
      }

      function addToCart(event) {
        if (!isComplete() || busy) return;
        var errorEl = root.querySelector('[data-discovery-error]');
        if (errorEl) errorEl.hidden = true;
        var boxId = parseInt(root.getAttribute('data-discovery-box-id'), 10) || 0;
        if (!boxId) {
          if (errorEl) errorEl.hidden = false;
          return;
        }
        busy = true;
        syncButton();
        var values = ids().filter(function (id) { return id > 0; });
        // One visible line-item property per coffee ("Kawa 1: Colombia · Pink Bourbon — Huila · Washed"),
        // so the order shows exactly which three bags to pack. The label prefix is a section setting.
        var lotLabel = root.getAttribute('data-discovery-lot-label') || 'Kawa';
        var lotNames = values.map(function (id) {
          var card = root.querySelector('[data-discovery-lot="' + id + '"]');
          if (!card) return '';
          return card.getAttribute('data-discovery-full') || card.getAttribute('data-discovery-title') || card.getAttribute('data-discovery-origin') || '';
        });
        var grindEl = root.querySelector('[data-discovery-grind]:checked');
        var grind = grindEl ? grindEl.value : 'Całe ziarno';
        // Insertion order = display order in the cart and order: Kawa 1–3, then grind, then hidden lot ids.
        var fields = { id: String(boxId), quantity: '1' };
        lotNames.forEach(function (name, i) {
          fields['properties[' + lotLabel + ' ' + (i + 1) + ']'] = name;
        });
        fields['properties[Mielenie]'] = grind;
        fields['properties[_lot_1]'] = String(values[0]);
        fields['properties[_lot_2]'] = String(values[1]);
        fields['properties[_lot_3]'] = String(values[2]);
        var endpoint = (root.getAttribute('data-cart-add') || '/cart/add.js').replace(/\.js$/, '');
        var form = document.createElement('form');
        form.method = 'post';
        form.action = endpoint;
        form.hidden = true;
        Object.keys(fields).forEach(function (name) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = fields[name];
          form.appendChild(input);
        });
        var trigger = event && event.currentTarget;
        var submitter = document.createElement('button');
        submitter.type = 'submit';
        submitter.tabIndex = -1;
        submitter.setAttribute('aria-hidden', 'true');
        if (trigger && trigger.getBoundingClientRect) {
          var r = trigger.getBoundingClientRect();
          submitter.style.cssText = 'position:fixed;left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;opacity:0;pointer-events:none;';
          form.hidden = false;
        }
        // The fly-to-cart animation measures this real button when it starts (after the add request),
        // not the click-time coordinates: on iPhone the Safari toolbar / sticky bar can move in between.
        if (trigger) submitter._voitkusFlyFrom = trigger;
        form.appendChild(submitter);
        document.body.appendChild(form);
        try {
          if (form.requestSubmit) {
            form.requestSubmit(submitter);
          } else {
            submitter.click();
          }
        } catch (err) {
          if (errorEl) errorEl.hidden = false;
        }
        window.setTimeout(function () {
          if (form.parentNode) form.parentNode.removeChild(form);
          busy = false;
          syncButton();
        }, 1500);
      }

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var current = parseInt(select.value, 10) || 0;
          var values = ids();
          if (current && values.filter(function (id) { return id === current; }).length > 1) {
            select.value = '';
          }
          sync();
        });
      });

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event.target.closest('a')) return;
          var id = parseInt(card.getAttribute('data-discovery-lot'), 10) || 0;
          if (id) assignLot(id);
        });
        card.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          var id = parseInt(card.getAttribute('data-discovery-lot'), 10) || 0;
          if (id) assignLot(id);
        });
      });

      root.querySelectorAll('[data-discovery-ui-slot]').forEach(function (el) {
        el.addEventListener('click', function () {
          var index = parseInt(el.getAttribute('data-discovery-ui-slot'), 10);
          var values = ids();
          if (!selects[index] || !values[index]) {
            var catalog = root.querySelector('[data-discovery-pool]');
            if (catalog && catalog.scrollIntoView) {
              catalog.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
            return;
          }
          selects[index].value = '';
          sync();
        });
      });

      buttons.forEach(function (button) {
        button.addEventListener('click', addToCart);
      });

      sync();
    }

    function boot() {
      document.querySelectorAll('.discovery-product').forEach(function (root) {
        if (root.getAttribute('data-discovery-ready')) return;
        root.setAttribute('data-discovery-ready', '1');
        initPicker(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Theme editor: a re-rendered section is a fresh root without data-discovery-ready.
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    'use strict';
    // "Ustawienia cookies" opens Shopify's consent preferences; without the banner API the link
    // falls back to the cookies page.
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-shopify-cookie-preferences]');
      if (!link) return;
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        e.preventDefault();
        window.privacyBanner.showPreferences();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var hero = document.querySelector('[data-home-hero]');
    if (!hero || hero.__vkHeroInit) return;
    var stage = hero.querySelector('.home-hero__stage');
    if (!stage) return;
    hero.__vkHeroInit = true;
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hex = function (h) {
      var m = String(h || '').trim().match(/^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
      return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null;
    };
    var from = hex(hero.getAttribute('data-from')) || [255, 79, 0];
    var to = hex(hero.getAttribute('data-to')) || [255, 255, 255];

    // Scroll-linked wash: --home-wash on <html>, progress --p on the stage, html/body.is-light for the header.
    // Last written values are cached so frames where nothing changed don't invalidate styles.
    var ticking = false;
    var lastWash = '';
    var lastP = '';
    var lastLit = null;
    var sync = function () {
      ticking = false;
      var p = Math.min(1, Math.max(0, window.scrollY / (window.innerHeight * 0.7)));
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      var c = from.map(function (v, i) { return Math.round(v + (to[i] - v) * e); });
      var wash = 'rgb(' + c.join(',') + ')';
      if (wash !== lastWash) {
        root.style.setProperty('--home-wash', wash);
        lastWash = wash;
      }
      var pv = reduce ? '0' : e.toFixed(3);
      if (pv !== lastP) {
        stage.style.setProperty('--p', pv);
        lastP = pv;
      }
      var lit = p > 0.85;
      if (lit !== lastLit) {
        root.classList.toggle('is-light', lit);
        document.body.classList.toggle('is-light', lit);
        lastLit = lit;
      }
    };
    // Logo unosi się przy przewijaniu, ale nigdy nie wjeżdża pod pasek nawigacji.
    var markEl = hero.querySelector('.home-hero__mark');
    var fitLift = function () {
      if (!markEl || window.scrollY > 4) return;
      stage.style.removeProperty('--hh-lift');
      var chrome = document.querySelector('.site-chrome');
      var chromeBottom = chrome ? chrome.getBoundingClientRect().bottom : 0;
      var room = markEl.getBoundingClientRect().top - chromeBottom - 16;
      var want = parseFloat(getComputedStyle(stage).getPropertyValue('--hh-lift')) * window.innerHeight / 100 || 0;
      stage.style.setProperty('--hh-lift', Math.max(0, Math.min(want, room)).toFixed(0) + 'px');
    };
    // resize can fire many times per frame; fitLift forces layout, so measure + repaint at most once per frame.
    var resizeQueued = false;
    var onResize = function () {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(function () {
        resizeQueued = false;
        fitLift();
        sync();
      });
    };
    fitLift();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLift);
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
    sync();

    // roast curve (as in the logo): bottom turn sits under the buttons, branches go around the text
    var curve = hero.querySelector('[data-hero-curve]');
    var drawCurve = function () {
      if (!curve) return;
      var st = stage.getBoundingClientRect();
      var W = st.width, H = Math.min(st.height, window.innerHeight - Math.max(0, st.top));
      if (!W || !H) return;
      var r = function (sel) {
        var el = hero.querySelector(sel);
        if (!el) return null;
        var b = el.getBoundingClientRect();
        return { l: b.left - st.left, r: b.right - st.left, t: b.top - st.top, b: b.bottom - st.top };
      };
      var mark = r('.home-hero__mark'), kick = r('.home-hero__kicker'), tag = r('.home-hero__tagline'), cta = r('.home-hero__ctas');
      var boxes = [mark, kick, tag, cta].filter(Boolean);
      if (!cta || !mark) return;
      var pad = Math.max(16, W * 0.025);
      var cue = r('.home-hero__cue');
      var floor = Math.min(cue ? cue.t - 10 : H, H - 34);
      var tpY = Math.max(cta.b + 16, Math.min(floor, cta.b + Math.max(28, (floor - cta.b) * 0.55)));
      tpY = Math.min(tpY, H - 3);
      var tpX = (cta.l + cta.r) / 2;
      var left = Math.min.apply(null, boxes.map(function (b) { return b.l; }));
      var lowRight = Math.max(cta.r, tag ? tag.r : 0);
      var kRight = Math.max(kick ? kick.r : 0, mark.r);
      var clampX = function (x) { return Math.max(4, Math.min(W - 4, x)); };
      var y0 = mark.t + (mark.b - mark.t) * 0.25;
      var yEnd = mark.t + (mark.b - mark.t) * 0.15;
      var f = function (n) { return n.toFixed(1); };
      // left branch: steep drop, round bottom with a flat tangent under the buttons
      var d = 'M0,' + f(y0) +
        ' C' + f(Math.min(tpX * 0.3, left * 0.4)) + ',' + f(y0 + (tpY - y0) * (left < W * 0.1 ? 0.92 : 0.62)) + ' ' + f(Math.max(0, Math.min(tpX * 0.55, cta.l - pad * 2))) + ',' + f(tpY) + ' ' + f(tpX) + ',' + f(tpY);
      // right branch: long rise around the text, flattening at the top like the logo
      var pts = [
        [tpX, tpY],
        [clampX(lowRight + pad * 1.4), cta.b + (tpY - cta.b) * 0.15],
        [clampX(kRight + (W - kRight) * 0.45), (kick ? kick.b : mark.b) + pad * 1.6],
        [clampX(kRight + (W - kRight) * 0.72), mark.t + (mark.b - mark.t) * 0.35],
        [W, yEnd]
      ];
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[i - 1], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || pts[i + 1];
        var c1 = i === 0 ? [p1[0] + (p2[0] - p1[0]) * 0.45, p1[1]] : [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6];
        var c2 = [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
        if (i === 0) c2[1] = Math.min(c2[1], tpY);
        d += ' C' + f(c1[0]) + ',' + f(c1[1]) + ' ' + f(c2[0]) + ',' + f(c2[1]) + ' ' + f(p2[0]) + ',' + f(p2[1]);
      }
      curve.setAttribute('viewBox', '0 0 ' + W.toFixed(0) + ' ' + st.height.toFixed(0));
      curve.querySelector('path').setAttribute('d', d);
      if (curve.getAttribute('data-dots') === '1') {
        var dots = curve.querySelectorAll('circle');
        [0, 1, 2, 3].forEach(function (pi, n) {
          var c = dots[n];
          if (!c) {
            c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            c.style.setProperty('--d', (0.2 + 2.2 * pts[pi][0] / W).toFixed(2) + 's');
            curve.appendChild(c);
          }
          c.setAttribute('cx', pts[pi][0].toFixed(1)); c.setAttribute('cy', pts[pi][1].toFixed(1));
        });
      }
      if (!curve.classList.contains('is-drawn')) {
        if (reduce) curve.classList.add('is-static');
        curve.classList.add('is-drawn');
      }
    };
    if (curve) {
      requestAnimationFrame(drawCurve);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawCurve);
      setTimeout(drawCurve, 1300);
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (window.scrollY < 10) drawCurve(); }, 150); });
    }

    // reveal-on-scroll for all home 2026 sections
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-taste"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var roots = document.querySelectorAll('.home-taste');
    if (!roots.length) return;

    // Krótki komunikat dla niewidocznego regionu statusu, np. „Twoja kawa na start: Etiopia”.
    var describe = function (answer) {
      var label = answer.querySelector('.home-taste__lbl');
      var title = answer.querySelector('h3');
      return [label ? label.textContent.trim() : '', title ? title.textContent.trim() : ''].filter(Boolean).join(': ');
    };

    roots.forEach(function (root) {
      if (root.__vkTasteInit) return;
      var opts = root.querySelectorAll('[data-taste-opt]');
      if (!opts.length) return;
      root.__vkTasteInit = true;
      var answers = root.querySelectorAll('[data-taste-a]');
      var box = root.querySelector('.home-taste__answers');
      var status = root.querySelector('[data-taste-status]');
      var pick = function (btn) {
        var idx = btn.getAttribute('data-taste-opt');
        opts.forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
        answers.forEach(function (a) {
          var on = a.getAttribute('data-taste-a') === idx;
          a.classList.toggle('is-active', on);
          a.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (!on) return;
          if (box) {
            var c = getComputedStyle(a).getPropertyValue('--pc').trim();
            if (c) box.style.setProperty('--pc-active', c);
          }
          if (status) status.textContent = describe(a);
        });
        // Podświetla wybraną kawę w siatce „Aktualne loty” (home-lots: .home-lot[data-handle]).
        var h = btn.getAttribute('data-handle');
        document.querySelectorAll('.home-lot').forEach(function (l) { l.classList.toggle('is-picked', l.getAttribute('data-handle') === h); });
      };
      opts.forEach(function (o) { o.addEventListener('click', function () { pick(o); }); });
      // Zdjęcia ukrytych odpowiedzi dekodujemy z góry, żeby przy przełączaniu paczka nie pojawiała się z opóźnieniem.
      var warm = function () {
        root.querySelectorAll('.home-taste__img img').forEach(function (img) {
          img.loading = 'eager';
          if (img.decode) img.decode().catch(function () {});
        });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2000 }); else setTimeout(warm, 800);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parzenie"]) return;
  try {
    
  (function () {
    'use strict';

    // Diagnostic chips (.vk-chip, state via aria-pressed): show the hint for the chosen cup profile
    // and highlight the matching lever.
    function init(root) {
      if (!root || root.hasAttribute('data-brew-guides-ready')) return;
      root.setAttribute('data-brew-guides-ready', '');
      var chips = root.querySelectorAll('.brew-guides__pick');
      var levers = root.querySelectorAll('.brew-guides__lever');
      var title = root.querySelector('[data-out-title]');
      var hint = root.querySelector('[data-out-hint]');
      var kicker = root.querySelector('[data-out-kicker]');
      chips.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var lever = btn.getAttribute('data-lever') || '';
          chips.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          if (title) title.textContent = btn.getAttribute('data-title') || '';
          if (hint) hint.textContent = btn.getAttribute('data-hint') || '';
          var target = lever ? root.querySelector('#lever-' + lever) : null;
          if (kicker) {
            kicker.textContent = target
              ? 'Dźwignia ' + target.querySelector('b').textContent + ' · ' + target.querySelector('.brew-guides__k').textContent
              : 'Dźwignia';
          }
          levers.forEach(function (el) {
            el.classList.toggle('is-lit', lever !== '' && el.getAttribute('data-lever') === lever);
          });
        });
      });
    }

    init(document.querySelector('.brew-guides'));
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('.brew-guides'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
